import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Input } from "@heroui/react";
import { Icon } from "@iconify/react";

export function ProfilePage() {
  const history = useHistory();
  const [name, setName] = useState("João Silva");
  const [email, setEmail] = useState("joao.silva@example.com");
  const [profileImage, setProfileImage] = useState("https://img.heroui.chat/image/crm?w=200&h=200&u=2");

  const handleImageChange = () => {
    // In a real app, this would open an image picker or upload dialog
    const newImageUrl = prompt("Enter new image URL:");
    if (newImageUrl) {
      setProfileImage(newImageUrl);
    }
  };

  const handleSave = () => {
    // In a real app, this would save the changes to a backend
    alert("Perfil atualizado!");
  };

  return (
    <div className="min-h-screen bg-primary-500 flex flex-col">
      <div className="bg-primary-500 pt-6 pb-4 px-4">
        <div className="flex items-center justify-between max-w-2xl mx-auto">
          <Button 
            isIconOnly 
            variant="light" 
            onPress={() => history.goBack()}
          >
            <Icon icon="lucide:arrow-left" className="text-white text-xl" />
          </Button>
          <h1 className="text-white text-xl font-semibold">Perfil</h1>
          <div className="w-10"></div>
        </div>
      </div>

      <div className="bg-white rounded-t-3xl flex-1 pt-8 px-6">
        <div className="flex flex-col items-center">
          <div className="relative mb-6">
            <img 
              src={profileImage} 
              alt="Profile" 
              className="w-32 h-32 rounded-full object-cover"
            />
            <Button
              isIconOnly
              color="primary"
              className="absolute bottom-0 right-0 rounded-full w-10 h-10"
              onPress={handleImageChange}
            >
              <Icon icon="lucide:camera" className="text-xl" />
            </Button>
          </div>

          <div className="w-full space-y-4 max-w-md">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Nome</label>
              <Input
                value={name}
                onValueChange={setName}
                variant="bordered"
                radius="lg"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <Input
                value={email}
                onValueChange={setEmail}
                variant="bordered"
                radius="lg"
                disabled
              />
            </div>

            <Button 
              color="primary" 
              className="w-full mt-6"
              onPress={handleSave}
            >
              Salvar alterações
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
